<div class="demo-container">
  <div class="content-section">
    <p class="text-base">We know the general form of the binomial theorem:</p>
    <dojo-super-latex [content]="content1" />
  </div>

  <div class="content-section">
    <p class="text-base">Notice our expression matches the structure of the general form:</p>
    <dojo-super-latex [content]="content2" />
  </div>

  <div class="content-section">
    <p class="text-base">Therefore, we can substitute the values and use the binomial theorem to expand:</p>
    <dojo-super-latex [content]="content3" />
  </div>

  <div class="content-section">
    <p class="text-base">Rounded labels with mathematical operators:</p>
    <dojo-super-latex [content]="content4" />
  </div>

  <div class="content-section">
    <p class="text-base">Menu label (click the pulsing dot for more info):</p>
    <dojo-super-latex [content]="content5Menu" />
  </div>

  <div class="content-section">
    <p class="text-base">Native KaTeX labeling with \underset:</p>
    <dojo-super-latex [content]="contentQuadraticCoefficients" />
  </div>

  <div class="content-section">
    <p class="text-base">Pascal's Triangle with Binomial Expansion:</p>
    <dojo-super-latex [content]="contentPascalTriangle" />
  </div>

  <div class="content-section">
    <p class="text-base">Native KaTeX arrows (simple sequences):</p>
    <dojo-super-latex [content]="contentNativeKatexArrows" />
  </div>

  <div class="content-section">
    <p class="text-base">SuperLatex sequence (custom arrows):</p>
    <dojo-super-latex [content]="contentSuperLatexSequence" />
  </div>
</div>
